import {InputOrOutputInventory} from "./input-or-output-inventory"

export interface IHistoryInventory {
    id?: number;
    date?: string;
    userId?: number;
    userName?: string;
    providerId?: number;
    providerName?: string;
    consecutive?: number;
    items?: Array<InputOrOutputInventory>;
    totalCost?: number;
    itemsCount?: number;
    orderId?: number;
    comment?: string;
    authorize?: number;
    requests?: number;
    receptionDate?: string;
    active?: number;
    authorized?: number;
    stateId?: number;
    purchaseOrderId?: number;
    requestsName?: string;
    authorizeName?: string;
    orderNumber?: number;
    created?: string;
    createdBy?: number;
    updated?: string;
    updatedBy?: number;
    updateResources?: boolean;
    rentalorderId?: number;
   }

  export class HistoryInventory  implements IHistoryInventory  {
    id?: number;
    date?: string;
    userId?: number;
    userName?: string;
    providerId?: number;
    providerName?: string;
    consecutive?: number;
    items?: Array<InputOrOutputInventory>;
    totalCost?: number;
    itemsCount?: number;
    orderId?: number;
    comment?: string;
    authorize?: number;
    requests?: number;
    receptionDate?: string;
    active?: number;
    authorized?: number;
    stateId?: number;
    stateName?: string;
    purchaseOrderId?: number;
    requestsName?: string;
    authorizeName?: string;
    orderNumber?: number;
    warehouse?: string;
    warehouseId?: number;
    created?: string;
    createdBy?: number;
    updated?: string;
    updatedBy?: number;
    updateResources?: boolean;
    rentalorderId?: number;
  }
